import script from "./QuestionManager.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionManager.vue?vue&type=script&setup=true&lang=js"

import "./QuestionManager.vue?vue&type=style&index=0&id=6441227d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6441227d"]])

export default __exports__